import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { Subtitle } from "./StudyManagerShared.styles";
import { BaseTextButton, multilineEllipsis } from "./base.styles";
import { FlexColumn } from "./common.styles";
export const StudiesDetailParent = styled.div ``;
export const Columns = styled.div `
    display: flex;
    align-self: stretch;
    gap: 24px;
    align-items: flex-start;
`;
export const MainColumn = styled.div `
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 24px;
    padding: 24px 24px 24px 0;
`;
export const Section = styled.section `
    display: flex;
    flex-direction: column;
    gap: 16px;
`;
export const SectionTitleContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;
export const SectionTitleText = styled(Subtitle) `
    flex-grow: 1;
`;
export const SectionText = styled.div `
    white-space: pre-wrap;
`;
const SectionContentBase = styled.div `
    color: ${colors.black_light};
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    letter-spacing: 0.15px;
`;
export const SectionContentContainer = styled.div `
    & ul {
        margin-top: 0;
        padding-left: 24px;

        & li {
            padding-left: 4px;
        }
    }
`;
export const SectionContent = styled(SectionContentBase) ``;
const StudyContentTypeBase = styled(SectionContentBase) `
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    display: inline;
`;
export const StudyTypeEl = styled(StudyContentTypeBase) `
    span {
        font-weight: ${fontWeights.NORMAL};
        color: ${colors.black_light};
    }
`;
export const SecondColumn = styled.div `
    flex: 1;
    margin-top: 24px;
`;
export const DetailsSection = styled.div `
    display: flex;
    flex-direction: column;
    gap: 16px;
    border: 1px solid ${colors.black_30};
    border-radius: 4px;
    padding: 24px;
    margin-bottom: 24px;
`;
export const SubsectionTitle = styled.div `
    font-size: ${fontSizes.MEDIUM};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const DetailsLabel = styled.div `
    font-weight: ${fontWeights.SEMI_BOLD};
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_main};
    margin-bottom: 4px;
`;
export const DetailsValue = styled.div `
    font-size: ${fontSizes.STANDARD};
    color: ${colors.black_light};
`;
export const DetailsValueLink = styled(DetailsValue) `
    ${multilineEllipsis(1)}
    display: inline-block;
`;
export const DetailsLinkValue = styled(FlexColumn) `
    justify-content: flex-start;
`;
export const StyledLink = styled.a `
    padding: 0px;
    text-decoration: underline;
    &:hover {
        text-decoration: none;
    }
`;
export const DetailsNoValue = styled(DetailsValue) `
    font-style: italic;
`;
export const Link = styled(BaseTextButton) ``;
export const ContactHealthExToEdit = styled.div `
    color: ${colors.black_lighter};

    & a {
        color: ${colors.navy_main};
    }
`;
export const LinkWithIcon = styled(Link) `
    display: flex;
    gap: 8px;
    align-items: center;
    align-self: stretch;
    height: auto;
    justify-content: start;

    & svg {
        width: 20px;
        height: 20px;
    }
`;
